import { connect } from 'react-redux';
import { getDoubleMpu } from '../../../modules/JobsList';
import { getSearchType, getFullUrl } from '../../../modules/Settings';
import { ContextualContent } from './Contextual';
import { getNoAds } from '../../../modules/Filters';

const mapStateToProps = state => {
  const intRegex = new RegExp('international*', 'ig');
  const fullUrl = getFullUrl(state);
  const isInternational = intRegex.test(fullUrl);
  return {
    doubleMpu: getDoubleMpu(state),
    searchType: getSearchType(state),
    noAds: getNoAds(state),
    isInternational
  };
};

const mapCallbacksToProps = () => ({});

export const Contextual = connect(mapStateToProps, mapCallbacksToProps)(ContextualContent);
